import { useState, useEffect } from 'react';
import { ROLES, ROLES_CAP } from '../utils/Constants';

const useRole = () => {
  const role = localStorage.getItem('roles');
  const [currentRole, setCurrentRole] = useState<string>('');

  useEffect(() => {
    if (role) {
      if (role.includes(ROLES_CAP.producer)) {
        setCurrentRole(ROLES.producer);
      } else if (role.includes(ROLES_CAP.commercial)) {
        setCurrentRole(ROLES.commercial);
      } else if (role.includes(ROLES_CAP.comite)) {
        setCurrentRole(ROLES.comite);
      } else if (role.includes(ROLES_CAP.instrumentator)) {
        setCurrentRole(ROLES.instrumentator);
      }
    }
  }, [role]);

  const isProducer = currentRole === ROLES.producer;
  const isCommercial = currentRole === ROLES.commercial;
  const isComite = currentRole === ROLES.comite;
  const isInstrumentator = currentRole === ROLES.instrumentator;

  return {
    isProducer,
    isCommercial,
    isComite,
    isInstrumentator,
    currentRole,
  };
};

export default useRole;